export default {
    SET_ORDERS(state, orders) {
        state.orders = orders;
    },
    SET_PRE_ORDERS(state, pre_orders) {
        state.pre_orders = pre_orders;
    },
    UPDATE_ORDERS(state, orders) {
        const orderIndex = state.orders.items.findIndex((order) => order.id === orders.id);
        Object.assign(state.orders.items[orderIndex], orders);
    },
    UPDATE_PRE_ORDERS(state, orders) {
        const orderIndex = state.pre_orders.items.findIndex((order) => order.id === orders.id);
        Object.assign(state.pre_orders.items[orderIndex], orders);
    },
}